// ============================================================================
// UTM & paramètres de campagne
//   Capturés au 1er chargement, persistés en sessionStorage, propagés sur
//   chaque page (URL) et transmis à cal.com. Survivent aux navigations tant
//   que l'onglet reste ouvert.
// ============================================================================

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id",
  "gclid",
  "fbclid",
] as const;

const STORAGE_KEY = "funnel_utms";

export type Utms = Record<string, string>;

export function getStoredUtms(): Utms {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Utms) : {};
  } catch {
    return {};
  }
}

// Lit les UTM de l'URL courante, fusionne avec l'existant (dernier contact
// écrase), persiste, et renvoie l'ensemble.
export function captureUtms(): Utms {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const found: Utms = {};
  for (const k of UTM_KEYS) {
    const v = params.get(k);
    if (v) found[k] = v;
  }
  const merged = { ...getStoredUtms(), ...found };
  if (Object.keys(found).length) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
    } catch {
      /* stockage indisponible : on continue sans persister */
    }
  }
  return merged;
}

// Ajoute les UTM stockés à un chemin/URL (en préservant un éventuel #hash).
export function appendUtms(path: string): string {
  const utms = getStoredUtms();
  if (!Object.keys(utms).length) return path;
  const [base, hash] = path.split("#");
  const sep = base.includes("?") ? "&" : "?";
  const qs = new URLSearchParams(utms).toString();
  return `${base}${sep}${qs}${hash ? "#" + hash : ""}`;
}
